const observerOptions: IntersectionObserverInit = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1,
};

const intersectionObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      intersectionObserver.unobserve(entry.target);
    }
  });
}, observerOptions);

const mutationObserver = new MutationObserver(() => {
  document.querySelectorAll('.fade-in-section:not(.is-visible)').forEach(el => {
    intersectionObserver.observe(el);
  });
});

mutationObserver.observe(document.body, { childList: true, subtree: true });

document.querySelectorAll('.fade-in-section').forEach(el => {
  intersectionObserver.observe(el);
});
